'use client'
import { getCookiePhoneNumber } from 'app/actions/affiliate.actions';
import { useEffect, useState } from 'react';

export function AffiliatePhone(props: { defaultPhone?: string }) {
  const { defaultPhone } = props;
  const [phoneNumber, setPhoneNumber] = useState<any>(null);
  useEffect(() => {
    const oninit = async () => {
      const leadPhoneNumber = await getCookiePhoneNumber();
      setPhoneNumber(leadPhoneNumber || defaultPhone || '833-606-4477');
    }
    oninit();
  }, []);

  return <span>{phoneNumber}</span>;
}
